import { useTableColumns } from './Hooks/useTableColumns';
import { useTableHeaderContextMenu } from './Hooks/useTableHeaderContextMenu';
import { useTablePrevValuesCache } from './Hooks/useTablePrevValuesCache';
import { useTableRef } from './Hooks/useTableRef';
import { useTableRows } from './Hooks/useTableRows';
import { useTableVirtualList } from './Hooks/useTableVirtualList';
export function useTable(props) {
    const tableColumnsResult = useTableColumns(props.columns, props.settings, props.onVisibleColumnsChange, props.onSortedColumnIdsChange);
    const tableRowsResult = useTableRows(props.rows, tableColumnsResult.sortingRules, tableColumnsResult.groupColumn, props.onSelectedRowsChanged, props.onRowDoubleClick, props.onCellClick, props.selectedRowIds);
    const tablePrevValuesCacheResult = useTablePrevValuesCache(props.columns, props.rows, props.subscribeRowUpdate);
    const tableVirtualListResult = useTableVirtualList(tableRowsResult.visibleRows.length, props.externalScrollRef);
    const tableHeaderContextMenuResult = useTableHeaderContextMenu(props.columns, tableColumnsResult.visibleColumns, tableColumnsResult.toggleColumnVisibility, tableColumnsResult.resetToDefaultVisibility);
    const tableResult = {
        tableColumnsResult,
        tableRowsResult,
        tablePrevValuesCacheResult,
        tableVirtualListResult,
        tableHeaderContextMenuResult
    };
    useTableRef(props.ref, tableResult);
    return tableResult;
}
